import { render, staticRenderFns } from "./PartnerCard.vue?vue&type=template&id=583c13a8&scoped=true&"
import script from "./PartnerCard.vue?vue&type=script&lang=ts&"
export * from "./PartnerCard.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerCard.vue?vue&type=style&index=0&id=583c13a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c13a8",
  null
  
)

export default component.exports